import { defineMessages } from 'react-intl';

const scope = 'app.containers.shared.PeriodSelectionModal';

export default defineMessages({
    title: {
        id: `${scope}.title`,
        defaultMessage: 'Select a period',
    },
    cancelButton: {
        id: `${scope}.buttons.cancel`,
        defaultMessage: 'Cancel',
    },
    confirmButton: {
        id: `${scope}.buttons.confirm`,
        defaultMessage: 'Confirm period',
    },
    // Year field
    yearFieldLabel: {
        id: `${scope}.fields.year.label`,
        defaultMessage: 'Year',
    },
    // Period type field
    periodTypeFieldLabel: {
        id: `${scope}.fields.periodType.label`,
        defaultMessage: 'Would you like a select a predefined period or customised dates?',
    },
    predefinedPeriodOptionLabel: {
        id: `${scope}.fields.periodType.options.predefinedPeriod`,
        defaultMessage: 'Use predefined period',
    },
    customPeriodOptionLabel: {
        id: `${scope}.fields.periodType.options.customPeriod`,
        defaultMessage: 'Use customised dates',
    },
    // Grouping field
    groupingFieldLabel: {
        id: `${scope}.fields.grouping.label`,
        defaultMessage: 'Time period',
    },
    weeklyGroupingLabel: {
        id: `${scope}.fields.grouping.options.weekly`,
        defaultMessage: 'Week',
    },
    monthlyGroupingLabel: {
        id: `${scope}.fields.grouping.options.monthly`,
        defaultMessage: 'Month',
    },
    quarterlyGroupingLabel: {
        id: `${scope}.fields.grouping.options.quarterly`,
        defaultMessage: 'Quarter',
    },
    groupingByLabel: {
        id: `${scope}.fields.grouping.dropdownPrefix`,
        defaultMessage: 'By:',
    },
    // Period selection field
    noMatchingPeriodsMessage: {
        id: `${scope}.fields.predefinedPeriod.noMatchingPeriodsMessage`,
        defaultMessage: 'There are no defined periods for selected year and time period.',
    },
    missingPeriodErrorMessage: {
        id: `${scope}.fields.predefinedPeriod.missingPeriodErrorMessage`,
        defaultMessage: 'You must select a period to proceed.',
    },
    errorFetchingPeriodsMessage: {
        id: `${scope}.fields.predefinedPeriod.errorFetchingPeriodsMessage`,
        defaultMessage: 'There was an error fetching your periods.',
    },
    retryButton: {
        id: `${scope}.fields.predefinedPeriod.retryButton`,
        defaultMessage: 'Retry',
    },
    loadingPeriodsMessage: {
        id: `${scope}.fields.predefinedPeriod.loadingPeriodsMessage`,
        defaultMessage: 'Fetching your periods..',
    },
    // PointInTime (PIT) field
    pointInTimeFieldLabel: {
        id: `${scope}.fields.pit.label`,
        defaultMessage: 'Select point in time from which to look at the data from:',
    },
    pitTodayPresetLabel: {
        id: `${scope}.fields.pit.pickerPresets.today`,
        defaultMessage: 'Today',
    },
    pitLySpitPresetLabel: {
        id: `${scope}.fields.pit.pickerPresets.LYSPIT`,
        defaultMessage: 'LYSPIT',
    },
});
